//const base_url = "https://eighty1handymanbe.azurewebsites.net"
//const base_url = "https://eighty1handymantestbe.azurewebsites.net"
//const base_url = "http://localhost:8080"
const base_url = "http://localhost:3000";
//const base_url = process.env.REACT_APP_BASE_URL||"http://localhost:3000";
export default base_url